import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delete-predefined-parameter',
  templateUrl: './delete-predefined-parameter.component.html',
  styleUrls: ['./delete-predefined-parameter.component.css']
})
export class DeletePredefinedParameterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
